import { render, staticRenderFns } from "./HrvecChatbot.vue?vue&type=template&id=43309fba&scoped=true&"
import script from "./HrvecChatbot.vue?vue&type=script&lang=js&"
export * from "./HrvecChatbot.vue?vue&type=script&lang=js&"
import style0 from "./HrvecChatbot.vue?vue&type=style&index=0&id=43309fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43309fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VChip,VIcon,VSpacer})
